import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { registerIcons } from '@uifabric/styling';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import * as fas from '@fortawesome/free-solid-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';
import { loadTheme, createTheme  } from 'office-ui-fabric-react/lib/Styling';

loadTheme(createTheme({
  defaultFontStyle: { fontWeight: 'normal' },
}));

registerIcons({
  icons: {
    'Home': <Icon icon={fas.faHome}/>,
    'Teacher': <Icon icon={fas.faChalkboardTeacher} />,
    'School': <Icon icon={fas.faSchool} />,
    'Add': <Icon icon={fas.faPlus} />,
    'Search': <Icon icon={fas.faSearch} />,
    'ChevronUp': <Icon icon={fas.faChevronUp} />,
    'ChevronDown': <Icon icon={fas.faChevronDown} />,
    'ChevronUpSmall': <Icon icon={fas.faChevronUp} />,
    'ChevronDownSmall': <Icon icon={fas.faChevronDown} />,
    'CheckMark': <Icon icon={fas.faCheck} />,
    'Delete': <Icon icon={far.faTrashAlt} />,
    'Edit': <Icon icon={far.faEdit} />,
    'Close': <Icon icon={fas.faTimes} />,
    'ChromeClose': <Icon icon={fas.faTimes} />,
    'Cancel': <Icon icon={fas.faTimes} />,
    'Clear': <Icon icon={fas.faTimes} />,
    'Completed': <Icon icon={far.faCheckCircle} />,
    'GraduationCap': <Icon icon={fas.faGraduationCap} />,
    'Tasks': <Icon icon={fas.faTasks} />,
    'CaretSolidUp': <Icon icon={fas.faCaretUp} />,
    'CaretSolidDown': <Icon icon={fas.faCaretDown} />,
    'Database': <Icon icon={fas.faDatabase} />,
    'Modules': <Icon icon={fas.faCubes} />,
    'Book': <Icon icon={fas.faBook} />,
    'User': <Icon icon={far.faUser} />,
    'Sort': <Icon icon={fas.faSort} />,
    'SortUp': <Icon icon={fas.faSortAlphaDown} />,
    'SortDown': <Icon icon={fas.faSortAlphaUp} />,
    'Filter': <Icon icon={fas.faFilter} />,
    'StatusCircleCheckmark': <Icon icon={far.faCheckCircle} />,
    'Calendar': <Icon icon={far.faCalendarAlt} />,
    'CalendarCheck': <Icon icon={far.faCalendarCheck} />,
    'CalendarEmpty': <Icon icon={far.faCalendar} />,
    'Dice': <Icon icon={fas.faDiceTwo} />,
    'Compress': <Icon icon={fas.faCompress} />,
    'CompressAlt': <Icon icon={fas.faCompressAlt} />,
    'Print': <Icon icon={fas.faPrint} />,
    'Save': <Icon icon={far.faSave} />,
    'More': <Icon icon={fas.faBars} />,
    'Warning': <Icon icon={fas.faExclamationCircle} />,
    'Error': <Icon icon={fas.faTimesCircle} />,
    'ErrorBadge': <Icon icon={fas.faTimesCircle} />,
    'SignOut': <Icon icon={fas.faSignOutAlt} />,
    'Refresh': <Icon icon={fas.faSyncAlt} />,
    'Up': <Icon icon={fas.faChevronUp} />,
    'Down': <Icon icon={fas.faChevronDown} />,
    'Info': <Icon icon={fas.faExclamationCircle} />,
    'Download': <Icon icon={fas.faDownload} />
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
